import { $axios } from 'src/boot/axios';

const defaultState = () => ({
  template: undefined,
  form: {
    documentsCount: 3,
    templateType: undefined,
  },
  documents: [],
  generation: undefined,
  currentMobileTab: 'inputs',
  mobileTabs: [{ value: 'inputs', label: 'Inputs' }, { value: 'contents', label: 'Contents' }],
});

const transformFormToModel = (fieldsSchema, form) => {
  const result = { data: { meta: {} } };
  Object.keys(fieldsSchema).forEach((item) => {
    if (fieldsSchema[item].isMeta === false) {
      result.data[item] = form[item];
    } else {
      result.data.meta[item] = form[item];
    }
  });
  result.data.templateType = form.templateType;
  result.documentsCount = form.documentsCount;
  return result;
};

const transformBrandVoice = (fieldsSchema) => {
  if (!fieldsSchema.brandVoice) { return; }
  fieldsSchema.toneOfVoice.brandVoice = fieldsSchema.brandVoice;
};

const actions = {
  async fetchTemplate({ commit }, { type }) {
    const { data } = await $axios.get(`generator/templates/${type}`);
    transformBrandVoice(data.data.fieldsSchema);
    commit('setTemplate', data.data);
    return data.data;
  },
  async createGeneration({ state, commit }) {
    const payload = transformFormToModel(state.template.fieldsSchema, state.form);
    const { data } = await $axios.post('generator/generations', payload);
    commit('setDocuments', data.data.documents);
    commit('setGeneration', data.data);
    return data.data;
  },
  async updateGeneration({ state, commit }, { guid }) {
    const payload = transformFormToModel(state.template.fieldsSchema, state.form);
    const { data } = await $axios.put(`generator/generations/${guid}`, payload);
    commit('setDocuments', data.data.documents);
    return data.data;
  },
  async fetchGeneration({ commit }, { guid }) {
    const { data } = await $axios.get(`generator/generations/${guid}`);
    commit('setDocuments', data.data.documents);
    commit('setGeneration', data.data);
    return data.data.documents;
  },
  async deleteDocument({ state, commit }, { guid }) {
    await $axios.delete(`generator/documents/${guid}`);
    commit('setDocuments', state.documents.filter((document) => document.guid !== guid));
  },
  async updateRating({ commit }, { documentGuid, rating }) {
    await $axios.put(`generator/documents/${documentGuid}/rating`, {
      rating,
    });
    commit('setRating', { documentGuid, rating });
  },
};

const mutations = {
  setTemplate(state, payload) {
    state.template = payload;
  },
  setFormTemplateType(state, payload) {
    state.form.templateType = payload;
  },
  setDocuments(state, payload) {
    state.documents = payload;
  },
  setCurrentMobileTab(state, payload) {
    state.currentMobileTab = payload;
  },
  setFormFromGenerationByTemplate(state) {
    const { fieldsSchema } = state.template;
    Object.keys(fieldsSchema).forEach((fieldKey) => {
      if (fieldsSchema[fieldKey].isMeta === false) {
        state.form[fieldKey] = state.generation[fieldKey];
      } else {
        state.form[fieldKey] = state.generation.meta[fieldKey];
      }
    });
  },
  setForm(state, { scope, payload }) {
    state.form[scope] = payload;
  },
  setGeneration(state, payload) {
    state.generation = payload;
  },
  setRating(state, { documentGuid, rating }) {
    const document = state.documents.find((item) => item.guid === documentGuid);
    document.rating = rating;
  },
  clear(state) {
    const clearState = defaultState();
    Object.keys(clearState).forEach((key) => {
      state[key] = clearState[key];
    });
  },
};

export default {
  namespaced: true,
  mutations,
  actions,
  state: defaultState,
};
